import { useEffect } from 'react';
import { CalendarView } from './components/Calendar';
import { ThemeProvider, ThemeSelector } from './components/Theme';
import { OfflineIndicator } from './components/PWA';
import { ErrorBoundary } from './components/Common';
import { useAuthStore } from './store/authStore';
import './styles/globals.css';

function App() {
  const { setToken, fetchProfile } = useAuthStore();

  // Handle OAuth callback - capture token from URL
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get('token');
    const error = params.get('error');

    if (token) {
      // Store token and fetch user profile
      setToken(token);
      fetchProfile();
      // Clean URL
      window.history.replaceState({}, document.title, window.location.pathname);
    } else if (error) {
      console.error('OAuth error:', error);
      // Clean URL
      window.history.replaceState({}, document.title, window.location.pathname);
    }
  }, [setToken, fetchProfile]);

  return (
    <ErrorBoundary>
      <ThemeProvider>
        <OfflineIndicator />
        <CalendarView />
        <ThemeSelector />
      </ThemeProvider>
    </ErrorBoundary>
  );
}

export default App;
